<!-- HTML -->
<template>
  <div>

    <section class="albums-container">
      <div class="columns">
        <div class="column is-half">
          <div class="product-container">
            <figure class="image is-square trigger">
              <img class="sprite-top-left" src="../../assets/img/store/cd-the-factory-bloc.jpg" alt="Cover artwork for Jugem's Cloud album The Factory Bloc">
              <img class="sprite-top-right" src="../../assets/img/store/cd-the-factory-bloc.jpg" alt="Cover artwork for Jugem's Cloud album The Factory Bloc">
              <img class="sprite-bot-right" src="../../assets/img/store/cd-the-factory-bloc.jpg" alt="Cover artwork for Jugem's Cloud album The Factory Bloc">
              <img class="sprite-bot-left" src="../../assets/img/store/cd-the-factory-bloc.jpg" alt="Cover artwork for Jugem's Cloud album The Factory Bloc">
              <div class="reveal-details">
                <h5>
                  <i>The Factory Bloc</i> [2020]
                  <br>
                  CD Digipak
                  <br>
                  6-Panel Full-Color
                  <br>
                  12 Tracks
                </h5>
                <h3>
                  <a href="https://jugemscloud.bandcamp.com/album/the-factory-bloc-2020" target="_blank">
                    Buy Now!
                  </a>
                </h3>
              </div>
              <div class="product-description-container">
                <div class="product-description">
                  <h1>
                    The Factory Bloc | CD
                  </h1>
                  <h3>
                    <i class="fas fa-dollar-sign"></i>6.99 USD + Shipping
                  </h3>
                </div>
              </div>
            </figure>
          </div>
        </div>
        <div class="column is-half">
          <div class="product-container">
            <figure class="image is-square trigger">
              <img class="sprite-top-left" src="../../assets/img/store/cd-nature-vs-humans.jpg" alt="Cover artwork for Jugem's Cloud album Nature Vs Humans">
              <img class="sprite-top-right" src="../../assets/img/store/cd-nature-vs-humans.jpg" alt="Cover artwork for Jugem's Cloud album Nature Vs Humans">
              <img class="sprite-bot-right" src="../../assets/img/store/cd-nature-vs-humans.jpg" alt="Cover artwork for Jugem's Cloud album Nature Vs Humans">
              <img class="sprite-bot-left" src="../../assets/img/store/cd-nature-vs-humans.jpg" alt="Cover artwork for Jugem's Cloud album Nature Vs Humans">
              <div class="reveal-details">
                <h5>
                  <i>Nature Vs Humans</i> [2014]
                  <br>
                  CD Digipak
                  <br>
                  8-Panel Full-Color
                  <br>
                  14 Tracks
                </h5>
                <h3>
                  <a href="https://jugemscloud.bandcamp.com/album/nature-vs-humans-2014" target="_blank">
                    Buy Now!
                  </a>
                </h3>
              </div>
              <div class="product-description-container">
                <div class="product-description">
                  <h1>
                    Nature Vs Humans | CD
                  </h1>
                  <h3>
                    <i class="fas fa-dollar-sign"></i>6.99 USD + Shipping
                  </h3>
                </div>
              </div>
            </figure>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-half">
          <div class="product-container">
            <figure class="image is-square trigger">
              <img class="sprite-top-left" src="../../assets/img/store/tee-contra-logo.png" alt="Jugem's Cloud Contra Tee">
              <img class="sprite-top-right" src="../../assets/img/store/tee-contra-logo.png" alt="Jugem's Cloud Contra Tee">
              <img class="sprite-bot-right" src="../../assets/img/store/tee-contra-logo.png" alt="Jugem's Cloud Contra Tee">
              <img class="sprite-bot-left" src="../../assets/img/store/tee-contra-logo.png" alt="Jugem's Cloud Contra Tee">
              <div class="reveal-details">
                <h5>
                  Factory Logo
                  <br>
                  Hanes Beefy T-Shirt
                  <br>
                  Heathered Ash Gray
                  <br>
                  Sizes: M | L
                </h5>
                <h3>
                  <a href="https://jugemscloud.bandcamp.com/merch/factory-logo-t-shirt" target="_blank">
                    Buy Now!
                  </a>
                </h3>
              </div>
              <div class="product-description-container">
                <div class="product-description">
                  <h1>
                    Factory Logo | T-Shirt
                  </h1>
                  <h3>
                    <i class="fas fa-dollar-sign"></i>19.99 USD + Shipping
                  </h3>
                </div>
              </div>
            </figure>
          </div>
        </div>
        <div class="column is-half">
          <div class="product-container">
            <figure class="image is-square trigger">
              <img class="sprite-top-left" src="../../assets/img/store/poster-the-factory-bloc.png" alt="Jugem's Cloud The Factory Bloc Poster">
              <img class="sprite-top-right" src="../../assets/img/store/poster-the-factory-bloc.png" alt="Jugem's Cloud The Factory Bloc Poster">
              <img class="sprite-bot-right" src="../../assets/img/store/poster-the-factory-bloc.png" alt="Jugem's Cloud The Factory Bloc Poster">
              <img class="sprite-bot-left" src="../../assets/img/store/poster-the-factory-bloc.png" alt="Jugem's Cloud The Factory Bloc Poster">
              <div class="reveal-details">
                <h5>
                  The Factory Bloc
                  <br>
                  11x17 Poster
                  <br>
                  Matte Finish
                </h5>
                <h3>
                  <a href="https://jugemscloud.bandcamp.com/merch/jugems-cloud-poster" target="_blank">
                    Buy Now!
                  </a>
                </h3>
              </div>
              <div class="product-description-container">
                <div class="product-description">
                  <h1>
                    The Factory Bloc | 11x17 Poster
                  </h1>
                  <h3>
                    <i class="fas fa-dollar-sign"></i>4.99 USD + Shipping
                  </h3>
                </div>
              </div>
            </figure>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<!-- JavaScript -->
<script>

export default {
  name: "HomeFeaturedStore"
};

</script>

<!-- CSS -->
<style lang="scss" scoped>

@import "../../assets/scss/variables.scss";

a {
  color: $green-tint-2;
  text-decoration: underline;
}
a:hover {
  color: $green;
}
h1 {
  font-family: astera;
  font-size: 1.4rem;
  color: $white;
}
h3 {
  font-family: astera;
  font-size: 1rem;
  color: $green-tint-2;
}
h5 {
  font-family: astera;
  font-size: 1rem;
  color: $white;
}

.column {
  padding: 0;
}
.trigger {
  position: relative;
}
.product-container {
  padding: 6rem;
  background: url("../../assets/img/home/green-concrete.jpg") no-repeat center center;
  background-size: cover;
  height: 100%;
  overflow: hidden;
}
.reveal-details {
  position: absolute;
  left: 15%;
  bottom: 15%;
  width: 70%;
  height: 70%;
  padding: 3.5rem;
  background-image: linear-gradient(135deg, $black, rgba(0,0,0,0.4));
  opacity: 0;
  transition: .6s;
  z-index: 0;
}
.product-description-container {
  position: absolute;
  left: -2rem;
  bottom: -2rem;
  padding: 2rem;
  border-top: 2px solid $green-tint-2;
  border-left: 2px solid $green-tint-2;
  background-image: linear-gradient(135deg, $black, rgba(0,0,0,0.4));
  z-index: 2;
}
/* Sprites */
.sprite-top-left {
	clip-path: inset(0 50% 50% 0);
	transition: .3s;
  z-index: 1;
}
.sprite-top-right {
	clip-path: inset(0 0 50% 50%);
	transition: .3s;
  transition-delay: .1s;
  z-index: 1;
}
.sprite-bot-right {
	clip-path: inset(50% 0 0 50%);
	transition: .3s;
  transition-delay: .2s;
  z-index: 1;
}
.sprite-bot-left {
	clip-path: inset(50% 50% 0 0);
	transition: .3s;
  transition-delay: .3s;
  z-index: 1;
}
.trigger:hover > img:nth-child(1) {
	transform: translateX(-35%) rotate(20deg);
  z-index: -2;
}
.trigger:hover > img:nth-child(2) {
	transform: translateY(-35%) rotate(20deg);
  z-index: -1;
}
.trigger:hover > img:nth-child(3) {
	transform: translateX(35%) rotate(20deg);
  z-index: -1;
}
.trigger:hover > img:nth-child(4) {
	transform: translateY(35%) rotate(20deg);
  z-index: -1;
}
.trigger:hover > .reveal-details {
  opacity: 1;
}

@media screen and (max-width: 512px) {
  .product-container {
    padding: 2rem !important;
  }
  .product-description-container {
    padding: 1.5rem;
  }
}

</style>
